module.exports = __webpack_public_path__ + "static/fonts/NanumGothic-Bold.60ccd86.woff2";